import styled from '@emotion/styled';
import { Color, FilledInfoIcon, PrimaryButton, SmallBasicModal } from '@liveoptics/react-ui';
import React, { useCallback, useState } from 'react';
import { TheaterType } from '../../../enums';
import { VerifyOwnerModal } from '../verify-owner/VerifyOwnerModal';

export interface VerifyOwnerNotificationModalProps {
  projectId: number;
  defaultTheater: TheaterType;
  onSuccess: () => void;
}

const GoldInfoIcon = styled(FilledInfoIcon)`
  fill: ${Color.gold500};
  color: ${Color.gold500};
`;

const Container = styled.div`
  padding: 18px 25px 25px 25px;
`;

const ModalText = styled.span`
  font-size: 14px;
  font-family: 'Open Sans';
  color: ${Color.coolGray700};
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 27px;
`;

export const VerifyOwnerNotificationModal = (props: VerifyOwnerNotificationModalProps) => {
  const [showNotifyModal, setShowNotifyModal] = useState<boolean>(true);
  const [showVerifyOwnerModal, setShowVerifyOwnerModal] = useState(false);
  const [success, setSuccess] = useState<boolean>(false);

  const toggleNotifyModal = useCallback((value: boolean) => () => setShowNotifyModal(value), []);
  const toggleVerifyOwnerModal = useCallback(
    (value: boolean) => () => {
      setShowVerifyOwnerModal(value);
      if (!value) setShowNotifyModal(false);
      if (!value && success) props.onSuccess();
    },
    [props, success]
  );
  const handleSuccess = useCallback(() => setSuccess(true), []);

  if (showNotifyModal) {
    return showVerifyOwnerModal ? (
      <VerifyOwnerModal
        projectId={props.projectId}
        defaultTheater={props.defaultTheater}
        onClose={toggleVerifyOwnerModal(false)}
        onSuccess={handleSuccess}
      />
    ) : (
      <SmallBasicModal
        modalTitle="Verify Owner"
        modalIcon={<GoldInfoIcon />}
        onClose={toggleNotifyModal(false)}
      >
        <Container>
          <ModalText>
            Please click Verify Owner to accurately assign the assets of this project. Please note
            if you close this modal, you will be reminded again in seven days to Verify Owner.
          </ModalText>
          <ButtonContainer>
            <PrimaryButton clickFn={toggleVerifyOwnerModal(true)}>Verify Owner</PrimaryButton>
          </ButtonContainer>
        </Container>
      </SmallBasicModal>
    );
  } else {
    return <></>;
  }
};
